"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _router = require("@reach/router");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _auth = require("../utils/auth");

var _actions = require("../actions"); // import app components


var db = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint, params, dispatch, config) {
    var user, formData, cleanedUrl, result, _err$response, _err$response$data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = (0, _auth.getUser)(config);

            if (!(user !== null && user !== void 0 && user.authToken) && !(0, _auth.isPreview)()) {
              _actions.authActions.signOut({
                callback: function callback() {
                  return (0, _router.navigate)('/');
                }
              }, dispatch, config);
            }

            _context.prev = 2;
            formData = new FormData();
            Object.keys(params).map(function (key) {
              return typeof params[key] !== 'undefined' && formData.append(key, params[key]);
            }); // TODO: Move to utils function

            cleanedUrl = config === null || config === void 0 ? void 0 : config.source.replace(/\/+$/, ''); // TODO: Make variable to allow for different CMS source

            _context.next = 8;
            return _axios.default.post("".concat(cleanedUrl, "/wp-json/jamcms/v1/").concat(endpoint), formData, {
              headers: {
                'Content-Type': 'x-www-form-urlencoded',
                Authorization: "Bearer ".concat(user.authToken)
              }
            });

          case 8:
            result = _context.sent;
            return _context.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);

            if (_context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.message) {
              if (endpoint === 'getAuthUser' || endpoint === 'getSite') {
                _actions.authActions.signOut({
                  callback: function callback() {
                    return (0, _router.navigate)('/');
                  }
                }, dispatch, config);
              } else {
                _antd.message.error((0, _htmlReactParser.default)(_context.t0.response.data.message));
              }
            }

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));

  return function db(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var _default = db;
exports.default = _default;